import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../auth/api";
import { alertSuccess, alertError } from "../../components/Alert";

// Fetch District List Data (with stateID)
export const fetchDistrictList = createAsyncThunk(
  "district/fetchDistrictList",
  async (stateID, { rejectWithValue }) => {
    try {
      let response;
      // console.log(stateID);

      if (!stateID || stateID === "undefined") {
        response = await api.get(`/location/panel/DistrictList`);
      } else {
        response = await api.get(`/location/panel/DistrictList?stateID=${stateID}`);
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Add District to the List
export const addDistrictList = createAsyncThunk(
  "district/addDistrictList",
  async (newDistrictData, { rejectWithValue }) => {
    try {
      const response = await api.post("/location/panel/DistrictList", newDistrictData);
      alertSuccess(response.data.success);
      return newDistrictData;
    } catch (error) {
      console.log(error.message);
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Update District List Data
export const updateDistrictList = createAsyncThunk(
  "district/updateDistrictList",
  async (districtData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/location/panel/DistrictList", districtData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// District List Slice
const districtSlice = createSlice({
  name: "district",
  initialState: {
    districtList: [],
    status: "idle",
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch District List
      .addCase(fetchDistrictList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchDistrictList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.districtList = action.payload;
      })
      .addCase(fetchDistrictList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Add District
      .addCase(addDistrictList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addDistrictList.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addDistrictList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Update District List
      .addCase(updateDistrictList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateDistrictList.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateDistrictList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearError } = districtSlice.actions;

export default districtSlice.reducer;
